import { verifyAdmin } from './admin/access';
import React from "react";
import Team from "./Team";
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle,
} from "chart.js";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Modal from "react-bootstrap/Modal";
import { Pie } from "react-chartjs-2";
import {
  usersReference,
  updateUser,
  picksReference,
  rankingsReference,
  tbMessage,
  getId,
  getWeek,
  leagueId,
  sleep,
  winnersReference,
  currYear
} from "./App";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
} from "./leagueStore";
import WeeklyStats from "./WeeklyStats";
import AdminWeekly from "./admin/AdminWeekly";
import { enterTiebreaker } from "./admin/tiebreaker";
import { recoverWinners } from "./winnerRecovery";
import { visibleStatsWeeks, hasPostedResults } from "./rules/statsVisibility";
import { Link } from "react-router-dom";
import StatsKeepers from "./StatsKeepers";
import StatsPersonal from "./StatsPersonal";
import StatsYear from "./StatsYear";
import StatsChallenges from "./StatsChallenges";
import { db } from "./Firebase";
import { readOnlyPreview } from "./leagueStore";
import { gsap } from "gsap";
// import { winnersArr } from "./pages/Stats";

// import Sonnet from "../../components/Sonnet";

export const getWinnersArr = async () => {
  const result = await getDocs(query(winnersReference, where("Year", "==", currYear)));
  return result.docs[0]?.data().Winners || [];
};
Chart.register(ArcElement, Tooltip, Legend);

class StatsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderedNIA: [],
      names1: [],
      users: [],
      users1: [],
      picks: [],
      week: -1,
      picksByWeek: [],
      nameIdArr: [],
      matchups: [],
      weekValid: false,
      accessLoaded: false,
      statsLoaded: false,
      hasPicks: false,
      hasRankings: false,
      winners: [],
      nameLoads: 0,
      recordsArr: [],
      cashArr: [],
      whoEveryonePicks: [],
      whoEachPersonPicks: [],
      myIndex: -1,
      pickEmResults: [],
      animated: false,
      loadCount: 0,
      rankingData: [],
      previewTiebreakers: {},
      isAdmin: false,
      showTiebreakerModal: false,
      tiebreakerWeek: -1,
      tiebreakerValue: "",
    };
    this.r1 = React.createRef();
    this.r2 = React.createRef();
    this.r3 = React.createRef();
    this.r4 = React.createRef();
    this.r5 = React.createRef();
    this.r6 = React.createRef();
    this.r7 = React.createRef();
  }

  //get all the picks and put them into state
  async getPickInfo() {
    let picksData = await getDocs(picksReference);
    let week = await getWeek();

    let data = picksData.docs
    .filter((doc) => doc.data().Year === currYear)
    .map((doc) => ({ ...doc.data(), id: doc.id }));
    console.log(data)
    await this.organizeByWeek(data);

    await this.setState({ picks: data, week: week });
  }

  organizeByWeek = (data) => {
    let empty = [
      ["NO USE"],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
      [],
    ];
    

    for (let i = 0; i < data.length; i++) {
      empty[data[i].Week].push(data[i]);
    }

    this.setState({ picksByWeek: empty });
  };

  //get names for all the Tids
  async getNames() {
    console.log("GETNAMES")
    let url = "https://api.sleeper.app/v1/league/" + leagueId + "/users";
    let tmp = [];
    let nms = [];

    await fetch(url, {
      method: "GET",
      headers: {
        // 'x-access-token': t
      },
    })
      .then((res) => res.json())
      .then((res) => {
        tmp = res;
      })
      .then(() => {
        for (let i = 0; i < tmp.length; i++) {
          let arr = [];
          arr.push(tmp[i].user_id);

          if (typeof tmp[i].metadata.team_name === "undefined") {
            arr.push(tmp[i].display_name);
          } else {
            arr.push(tmp[i].metadata.team_name);
          }

          nms.push(arr);
        }

        // this.getMatchups(nms, 1);
        this.getRosterOrder(nms);
        this.setState({ nameIdArr: nms });
        return this.analyzePicks(nms).then(() => this.getMyIndex(nms));

      });
  }

  getRosterOrder = (nIArr) => {
    let url = "https://api.sleeper.app/v1/league/" + leagueId + "/rosters";

    let teamInfo = [];
    let ids = [];

    fetch(url, {
      method: "GET",
      headers: {},
    })
      .then((res) => res.json())
      .then((res) => {
        teamInfo = res; //player info
      })
      .then(() => {
        ids = teamInfo.map((team) => {
          for (let i = 0; i < nIArr.length; i++) {
            if (nIArr[i][0] === team.owner_id) {
              return [team.owner_id, nIArr[i][1]];
            }
          }
        });
        // ids
        this.setState({ orderedNIA: ids });
        this.getMatchups(ids);
      })
      .then(() => {});
  };

  getMyIndex = async (arr) => {
    let id = await getId(usersReference);

    if (localStorage.getItem("name") === "guest") {
      id = "466461424856592384";
    }

    for (let i = 0; i < arr.length; i++) {
      if (arr[i][0] === id) {
        this.setState({ myIndex: i });
        break;
      }
    }
  };

  // Check if current user is admin
  checkIsAdmin = async () => {
    try {
      await verifyAdmin();
      this.setState({ isAdmin: true, adminSignInRequired: false });
      return true;
    } catch (error) {
      this.setState({ isAdmin: false, adminSignInRequired: error.code === 'admin/sign-in-required' });
      return false;
    }
  };

  // Handle tiebreaker modal close
  handleTiebreakerModalClose = () => {
    this.setState({
      showTiebreakerModal: false,
      tiebreakerWeek: -1,
      tiebreakerValue: ""
    });
  };

  // Handle tiebreaker input change
  handleTiebreakerInputChange = (event) => {
    this.setState({
      tiebreakerValue: event.target.value
    });
  };

  // Save tiebreaker and rerun addWinnerCheck
  saveTiebreaker = async () => {
    try { await verifyAdmin(); } catch (error) { alert(error.message); return; }
    const { tiebreakerWeek, tiebreakerValue } = this.state;
    
    if (!tiebreakerValue || tiebreakerValue.trim() === "") {
      alert("Please enter a valid tiebreaker value");
      return;
    }

    try {
      // Get winners document
      let q = query(
        winnersReference,
        where("Year", "==", currYear),
      );
      let winDocs = await getDocs(q);
      let winnersArr = winDocs.docs[0].data().Winners;
      let id = winDocs.docs[0].id;

      // Update tiebreaker for the specific week
      winnersArr[tiebreakerWeek].data.tiebreaker = tiebreakerValue;

      // Save to database
      let winnerDoc = doc(db, "Winners", id);
      let newFields = { Winners: winnersArr };
      await updateDoc(winnerDoc, newFields);

      // Close modal
      this.handleTiebreakerModalClose();

      // Rerun addWinnerCheck
      await this.analyzePicks(this.state.nameIdArr);
    } catch (error) {
      console.error("Error saving tiebreaker:", error);
      alert("Error saving tiebreaker. Please try again.");
    }
  };

  saveInlineTiebreaker = async (week, value) => {
    await verifyAdmin();
    let winners = this.state.winners;
    if (!winners[week]?.data?.picks?.length) {
      winners = await this.addWinnerCheck(this.state.picks);
      await new Promise(resolve => this.setState({ winners }, resolve));
    }
    if (!winners[week]?.data?.picks?.length) {
      throw new Error('Wait for all matchup results before entering the tiebreaker.');
    }
    const next = enterTiebreaker({ winners, week, value,
      cards:this.state.picks, matchups:this.state.matchups[week-1], currentWeek:getWeek() });
    if (readOnlyPreview) {
      await new Promise(resolve => this.setState({ previewTiebreakers:{...this.state.previewTiebreakers, [week]:next[week].data.tiebreaker} }, resolve));
    } else {
      const snapshot = await getDocs(query(winnersReference, where("Year", "==", currYear)));
      const stored = snapshot.docs[0];
      const fresh = [...(stored?.data().Winners || winners)];
      if (!fresh[week]?.data?.picks?.length) {
        fresh[week] = {...fresh[week], data:{...winners[week]?.data, ...fresh[week]?.data, picks:winners[week]?.data?.picks}};
      }
      const updated = enterTiebreaker({winners:fresh,week,value,cards:this.state.picks,matchups:this.state.matchups[week-1],currentWeek:getWeek()});
      if (stored) await updateDoc(doc(db,"Winners",stored.id),{Winners:updated});
      else await addDoc(winnersReference,{Year:currYear,Winners:updated});
    }
    await this.analyzePicks(this.state.nameIdArr);
  };

  async addWinnerCheck(cards = this.state.pickEmResults) {
    const isAdmin = await this.checkIsAdmin();
    const fetchJson = async path => {
      const response = await fetch(`https://api.sleeper.app/v1/league/${leagueId}${path}`);
      if (!response.ok) throw new Error("Sleeper results could not be loaded.");
      return response.json();
    };
    const result = await recoverWinners({
      year: currYear, currentWeek: getWeek(), cards,
      writable: !readOnlyPreview && localStorage.getItem("name") !== "guest" && Boolean(localStorage.getItem("email")),
      read: async () => {
        const snapshot = await getDocs(query(winnersReference, where("Year", "==", currYear)));
        return { id: snapshot.docs[0]?.id, winners: snapshot.docs[0]?.data().Winners || [] };
      },
      loadLeague: () => fetchJson(''), loadRosters: () => fetchJson('/rosters'), loadMatchups: week => fetchJson(`/matchups/${week}`),
      save: async (id, Winners) => {
        if (id) await updateDoc(doc(db, "Winners", id), { Winners });
        else await addDoc(winnersReference, { Year: currYear, Winners });
      },
    });
    this.setState({ recoveredWeeks: result.recoveredWeeks, recoveryError: result.saveError });
    if (isAdmin && !readOnlyPreview && !result.saveError && result.pendingTiebreakers.length) {
      this.setState({ showTiebreakerModal: true, tiebreakerWeek: result.pendingTiebreakers[0], tiebreakerValue: '' });
    }
    if (readOnlyPreview) {
      for (const [key, value] of Object.entries(this.state.previewTiebreakers)) {
        const week = Number(key);
        if (result.winners[week]?.data?.tiebreaker === '' || result.winners[week]?.data?.tiebreaker == null) {
          result.winners = enterTiebreaker({winners:result.winners, week, value, cards,
            matchups:this.state.matchups[week-1], currentWeek:getWeek()});
        }
      }
    }
    return result.winners;
  }

  animate = async (a) => {
    await sleep(50);

    if (this.state.loadCount == a) {
      gsap.from(this.r1.current, {
        y: "100%",
        duration: 2,
        ease: "power4",
        backgroundColor: "green",
        // scale: 0.1,
      });

      this.setState({ animated: true });
    }
  };

  async getRankings() {
    const rankingData = await getDocs(rankingsReference);
    let arr = rankingData.docs.filter((doc) => doc.data().Year === currYear).map((doc) => doc.data());
    this.setState({ rankingData: arr });
  }

  async componentDidMount() {
    this.setState({ animated: true });
    try {
      await this.checkWeekValid();
      await Promise.all([this.getPickInfo(), this.getRankings()]);
      await this.getNames();
    } catch (error) {
      this.setState({ statsError: "Stats couldn't load. Please refresh and try again." });
    }
  }

  async checkWeekValid() {
    const week = getWeek();
    const guest = localStorage.getItem("name") === "guest";
    const tid = guest ? null : await getId(usersReference);
    let hasPicks = false, hasRankings = false;
    if (tid) {
      const [picks, rankings] = await Promise.all([
        getDocs(query(picksReference, where("Tid", "==", tid), where("Week", "==", week), where("Year", "==", currYear))),
        getDocs(query(rankingsReference, where("Tid", "==", tid), where("Week", "==", week), where("Year", "==", currYear))),
      ]);
      hasPicks = !picks.empty;
      hasRankings = !rankings.empty;
    }
    await new Promise(resolve => this.setState({ week, hasPicks, hasRankings, weekValid: !guest && hasPicks && hasRankings, accessLoaded: true }, resolve));
  }

  availableWeeks() {
    return visibleStatsWeeks(this.state.week, this.state.hasPicks, this.state.hasRankings, localStorage.getItem("name") === "guest");
  }

  visibleData(data) {
    const weeks = this.availableWeeks();
    return data.filter(row => weeks.includes(Number(row.Week)));
  }

  weekAccessNotice() {
    if (this.state.weekValid || this.state.week > 18) return null;
    return <div className="flow-help">Past weeks are open to everyone. To see Week {this.state.week}, submit both picks and rankings.
      <div className="stats-action-links">{!this.state.hasPicks && <Link to="/pickem">Make your picks →</Link>}{!this.state.hasRankings && <Link to="/powerranking">Set your rankings →</Link>}</div>
      {localStorage.getItem("name") === "guest" && <span>You're exploring as a guest. Sign in to unlock your current week.</span>}
    </div>;
  }

  getMatchups = async (data) => {
    let weeksInASeason = 18;
    let final = [];
    for (let h = 1; h < weeksInASeason + 1; h++) {
      let arr = [];
      for (let k = 0; k < data.length / 2; k++) {
        arr.push([]);
      }
      let url =
        "https://api.sleeper.app/v1/league/" + leagueId + "/matchups/" + h; //other league for test

      // https://api.sleeper.app/v1/players/nfl

      let tmp = [];
      let all = [];
      let mNames = [];
      let rosters = [];
      let allPlayers = [];

      if (this.state.matchups.length == h - 1) {
        await fetch(url, {
          method: "GET",
          headers: {},
        })
          .then((res) => res.json())
          .then((res) => {
            tmp = res;
          })
          .then(() => {
            //iterate through tmp and find the matchups

            for (let i = 0; i < tmp.length; i++) {
              if (tmp[i].matchup_id == null) {
                continue;
              }
              arr[tmp[i].matchup_id - 1].push(data[tmp[i].roster_id - 1]);
            }

            final.push(arr);

            let t = this.state.matchups;
            t.push(arr);
            this.setState({ matchups: t });
          })
          .then(() => {});
      }
    }
  };

  getWeekTab() {
    if (this.state.statsError) return <p role="alert">{this.state.statsError}</p>;
    if (!this.state.accessLoaded || !this.state.statsLoaded) return <p role="status">Loading weekly stats…</p>;
    return <>{this.weekAccessNotice()}{this.state.recoveryError && <p role="alert">{this.state.recoveryError}</p>}{readOnlyPreview && this.state.recoveredWeeks?.length > 0 && <p className="stats-context">Preview only: calculated results have not been saved.</p>}<WeeklyStats weeks={this.availableWeeks()} picks={this.state.picks}
      rankings={this.state.rankingData} names={this.state.nameIdArr} winners={this.state.winners}
      currentWeek={this.state.week} tiebreakers={tbMessage} matchups={this.state.matchups} recoveredWeeks={this.state.recoveredWeeks}/></>;
  }

  getWeeklyCashReport = (nIArr, picks, rankings, winnersArr) => {
    let week = getWeek();
    let empty = [];
    for (let i = 1; i < week; i++) {
      empty.push(0);
    }

    console.log('picks :', picks);
    console.log('winnersArr :', winnersArr);

    let report = nIArr.map((t) => {
      return [t[0], t[1], ...empty];
    });

    if (winnersArr) {
      console.log("HELLOWss>>");
      for (let i = 0; i < picks.length; i++) {
        
        let noWins = 1;

        for (let j = 0; j < picks[i].Picks.length; j++) {
          if (winnersArr[picks[i].Week].data.picks.includes(picks[i].Ids[j])) {
            noWins = 0;
          }
        }

        for (let j = 0; j < report.length; j++) {
          // console.log(picks[i].Tid + " == " + report[j][0] + "?");
          if (picks[i].Tid === report[j][0]) {
            report[j][picks[i].Week + 1] += (1 - (noWins * 5));
            // console.log(`+${1 - (noWins * 5)} ${report[j][1]} | W${picks[i].Week} | Pickem`);
            break;
          }
        }
      }
    }
    

    for (let i = 0; i < rankings.length; i++) {
      for (let j = 0; j < report.length; j++) {
        if (rankings[i].Tid === report[j][0]) {
          report[j][rankings[i].Week + 1]++;
          // console.log(`+1 ${report[j][1]} | W${rankings[i].Week}: Rankings`);
          break;
        }
      }
    }

    for (let i = 1; i < week; i++) {
      for (let j = 0; j < report.length; j++) {
        if (winnersArr[i].data.winner_info[0] === report[j][0]) {
          report[j][i + 1] += winnersArr[i].data.winner_info[1];
          // console.log(`+${winnersArr[i].data.winner_info[1]} ${report[j][1]} | W${i}: ${report[j][i + 1]}: Winner`);
        }
      }
    }


    console.log('report :', report);

  };

  analyzePicks = async (nIArr) => {
    this.setState({ statsLoaded: false });
    // if (await getWeek() == 1) {
    //   return;
    // }

    const picksData = await getDocs(picksReference);
    let picks = picksData.docs.filter((doc) => doc.data().Year === currYear).map((doc) => ({ ...doc.data(), id: doc.id }));
    picks = this.visibleData(picks);
    this.setState({ pickEmResults: picks });

    // let winnersAr = await getDocs(winnersReference);
    let winnersArr;
    try { winnersArr = await this.addWinnerCheck(picks); }
    catch {
      winnersArr = await getWinnersArr();
      this.setState({ recoveryError: "Could not calculate missing results from Sleeper. Existing results are shown; refresh to retry." });
    }
    this.setState({ winners: winnersArr, resultsPending: !winnersArr.some(w => w?.data?.picks?.length) });
    if (!winnersArr.some(w => w?.data?.picks?.length)) {
      this.setState({ resultsPending: true, statsLoaded: true });
      await this.checkIsAdmin();
      return;
    }

    // X get every users record
    // X measure picks against and for
    // X get every users money
    // X measure who each user picks most and least


    
    // Scoring below only uses posted results; pending cards still count as submissions.
    let idsArr = [];
    let recordsArr = [];
    let cashArr = [];
    let whoEachPersonPicks = [];
    let whoEveryonePicks = [];

    for (let i = 0; i < nIArr.length; i++) {
      recordsArr.push([0, 0]);
      cashArr.push([0, 0, 0]);
      whoEveryonePicks.push(0);

      let tmp = [];
      for (let j = 0; j < nIArr.length; j++) {
        tmp.push(0);
      }
      tmp.push(0); //extra slot used to track how many picks the team has made
      whoEachPersonPicks.push(tmp);
    }

    for (let i = 0; i < picks.length; i++) {
      let teamI = -1; //id of the team that made the pick

      for (let j = 0; j < nIArr.length; j++) {
        if (nIArr[j][0] === picks[i].Tid) {
          teamI = j;
          break;
        }
      }

      if (teamI < 0) continue;
      cashArr[teamI][0]++;

      let wins = recordsArr[teamI][0];
      let currWins = recordsArr[teamI][0];
      let losses = recordsArr[teamI][1];
      let currLosses = recordsArr[teamI][1];



      let cash = cashArr[teamI][1];
      let noWins = 0;
      for (let j = 0; j < picks[i].Picks.length; j++) {

        if (picks[i].Week < (await getWeek()) && hasPostedResults(winnersArr, picks[i].Week)) {
          if (winnersArr[picks[i].Week].data.picks.includes(picks[i].Ids[j])) {
            wins++;
            
          } else {
            losses++;
            
          }
        }

        for (let h = 0; h < nIArr.length; h++) {
          if (picks[i].Ids[j] == nIArr[h][0]) {
            whoEveryonePicks[h]++;
            whoEachPersonPicks[teamI][h]++;

            break;
          }
        }
      }
      whoEachPersonPicks[teamI][nIArr.length]++;
      
      if (picks[i].Week < getWeek() && hasPostedResults(winnersArr, picks[i].Week) && wins - currWins == 0) {
        noWins++
      }

      if (
        picks[i].Week < (await getWeek()) &&
        winnersArr[picks[i].Week]?.data?.winner_info?.[0] === nIArr[teamI][0]
      ) {
        cash += winnersArr[picks[i].Week].data.winner_info[1];
      }

      recordsArr[teamI][0] = wins;
      recordsArr[teamI][1] = losses;
      cashArr[teamI][1] = cash - (noWins * 5);
    }

    for (let i = 0; i < this.state.rankingData.length; i++) {
      for (let j = 0; j < nIArr.length; j++) {
        if (this.availableWeeks().includes(Number(this.state.rankingData[i].Week)) && this.state.rankingData[i].Tid === nIArr[j][0]) {
          cashArr[j][2]++;
          break;
        }
      }
    }

    this.setState({
      recordsArr: recordsArr,
      statsLoaded: true,
      cashArr: cashArr,
      whoEveryonePicks: whoEveryonePicks,
      whoEachPersonPicks: whoEachPersonPicks,
    });


  };

  getYearTab() {}

  getKeepersTab() {
    if (true) {
      return <StatsKeepers />;
    }
  }

  changeWeek = (week) => {
    this.setState({ week: week });
  };

  getPersonalTab() {
    if (localStorage.getItem("name") === "guest") return <div className="empty-state"><h2>Your season, your stats.</h2><p>Sign in to see your personal record. As a guest, you can explore past weeks and the league's Year stats.</p><Link to="/">Go to league home →</Link></div>;
    if (this.state.statsError) return <p role="alert">{this.state.statsError}</p>;
    if (!this.state.statsLoaded) return <p role="status">Loading stats…</p>;
    if (this.state.resultsPending) return this.pendingSummary("me");
    if (this.state.myIndex > -1 && this.state.cashArr.length > 0) {
      // if (this.state.cashArr.length > 0) {
      return (
        <StatsPersonal
          picksByWeek={this.state.picksByWeek.map((rows, week) => this.availableWeeks().includes(week) ? rows : [])}
          currWeek={this.state.week}
          nameIdArr={this.state.nameIdArr}
          matchups={this.state.matchups}
          myIndex={this.state.myIndex}
          recordsArr={this.state.recordsArr}
          cash={this.state.cashArr[this.state.myIndex]}
          whoEveryonePicks={this.state.whoEveryonePicks}
          whoIPick={this.state.whoEachPersonPicks[this.state.myIndex]}
          pickEmResults={this.state.pickEmResults}
          whoEachPersonPicks={this.state.whoEachPersonPicks}
          rankingData={this.visibleData(this.state.rankingData)}
        />
      );
    }
  }

  getYearTab() {
    if (this.state.statsError) return <p role="alert">{this.state.statsError}</p>;
    if (!this.state.statsLoaded) return <p role="status">Loading stats…</p>;
    if (this.state.resultsPending) return this.pendingSummary("year");
    if (this.state.myIndex > -1 && this.state.recordsArr.length > 0) {
      // if (this.state.recordsArr.length > 0) {
      return (
        <StatsYear
          winners={this.state.winners}
          picksByWeek={this.state.picksByWeek.map((rows, week) => this.availableWeeks().includes(week) ? rows : [])}
          currWeek={this.state.week}
          nameIdArr={this.state.nameIdArr}
          matchups={this.state.matchups}
          myIndex={this.state.myIndex}
          recordsArr={this.state.recordsArr}
          cash={this.state.cashArr}
          whoEveryonePicks={this.state.whoEveryonePicks}
          whoIPick={this.state.whoEachPersonPicks[this.state.myIndex]}
          pickEmResults={this.state.pickEmResults}
          whoEachPersonPicks={this.state.whoEachPersonPicks}
          rankingData={this.visibleData(this.state.rankingData)}
        />
      );
    }
  }

  showTabs() {
    if (this.state.animated) {
      return "s";
    }
  }

  pendingSummary(view) {
    const guest = localStorage.getItem("name") === "guest";
    const names = view === "me" ? (guest ? [] : this.state.nameIdArr.filter((_, i) => i === this.state.myIndex)) : this.state.nameIdArr;
    const picks = this.visibleData(this.state.picks);
    const rankings = this.visibleData(this.state.rankingData);
    return <section className="pending-summary"><h2>{view === "me" ? "Your season" : "The season so far"}</h2>
      <p className="stats-context">Results are pending. Submitted cards are counted below; records and winnings will appear after results are posted.</p>
      {view === "me" && guest ? <p className="flow-help">Sign in to see your personal stats. You can explore past weeks and the league's Year stats as a guest.</p> : <div className="table-responsive"><table className="table"><thead><tr><th>Team</th><th>Pick cards</th><th>Rankings</th><th>Results</th></tr></thead><tbody>{names.map(([id, name]) => <tr key={id}><th scope="row">{name}</th><td>{picks.filter(p => p.Tid === id).length}</td><td>{rankings.filter(r => r.Tid === id).length}</td><td>Pending</td></tr>)}</tbody></table></div>}
      {this.weekAccessNotice()}
    </section>;
  }

  render() {
    return (
      <>
        <Container id="tabContainer" ref={this.r1}>
          {this.state.adminSignInRequired && localStorage.getItem('name') !== 'guest' && localStorage.getItem('email') && <div className="inline-notice" role="status">
            <div><strong>Sign in again to restore account access.</strong><p>This browser remembers your team, but your Google session is no longer active. Admin tools require an active sign-in.</p></div>
            <button className="button-primary" onClick={this.props.onSignIn}>Sign in with Google</button>
          </div>}
          <Tabs
            defaultActiveKey="personal"
            id="tab"
            className="stats-page-tabs"
            // mountOnEnter={true}
          >
            <Tab
              eventKey="personal"
              title={
                <>
                  <span className="stats-tab-short">Me</span>
                  <span className="stats-tab-full">My Stats</span>
                </>
              }
            >
              <Container>
                <Row>
                  <Col>{this.getPersonalTab()}</Col>
                  {/* TEMPORARILY UNAVAILABLE */}
                </Row>
              </Container>
            </Tab>
            <Tab eventKey="week" title="Week">
              {this.getWeekTab()}
              {/* TEMPORARILY UNAVAILABLE */}
            </Tab>
            <Tab eventKey="year" title="Year">
              <Container>
                <Row>
                  <Col>{this.getYearTab()}</Col>
                  {/* TEMPORARILY UNAVAILABLE */}
                </Row>
              </Container>
            </Tab>
            <Tab eventKey="keepers" title="Keepers">
              <Container>
                <Row>
                  <Col>
                    <StatsKeepers
                      picksByWeek={this.state.picksByWeek.map((rows, week) => this.availableWeeks().includes(week) ? rows : [])}
                      currWeek={this.state.week}
                      nameIdArr={this.state.nameIdArr}
                      matchups={this.state.matchups}
                    />
                  </Col>
                </Row>
              </Container>
            </Tab>
            <Tab eventKey="challenges" title="Challenges">
              <Container>
                <Row>
                  <Col>
                    <StatsChallenges isAdmin={this.state.isAdmin} />
                  </Col>
                </Row>
              </Container>
            </Tab>
            {this.state.isAdmin && <Tab eventKey="admin" title={readOnlyPreview ? 'Admin preview' : 'Admin'}>
              <AdminWeekly currentWeek={this.state.week} names={this.state.nameIdArr} picks={this.state.picks} rankings={this.state.rankingData} winners={this.state.winners} matchups={this.state.matchups} loaded={this.state.statsLoaded} onTiebreaker={this.saveInlineTiebreaker}/>
            </Tab>}
          </Tabs>
        </Container>

        {/* Tiebreaker Modal for Admin */}
        <Modal show={this.state.showTiebreakerModal} onHide={this.handleTiebreakerModalClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Enter Tiebreaker Value</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p><strong>Week {this.state.tiebreakerWeek}</strong></p>
            <p>{tbMessage[this.state.tiebreakerWeek]}</p>
            <Form.Group className="mb-3">
              <Form.Label>Enter the tiebreaker value:</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter number"
                value={this.state.tiebreakerValue}
                onChange={this.handleTiebreakerInputChange}
                autoFocus
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleTiebreakerModalClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.saveTiebreaker}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

<link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
  integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3"
  crossorigin="anonymous"
/>;

export default StatsContainer;
